import { fieldAnomaly } from '../../../../utils/formatter';
// ---------股权情况-----------
// 子公司的构成
export const subCompany = [
    {
        title: '子公司名称',
        dataIndex: 'Soncompanyname'
    },
    {
        title: '主要经营地',
        dataIndex: 'operarea'
    },
    {
        title: '业务性质',
        dataIndex: 'industry'
    },
    {
        title: '持股比例',
        dataIndex: 'holdingpropo',
        render: val => val + '%'
    },
    {
        title: '取得方式',
        dataIndex: 'Acqtype'
    }
];

// 前十大股东持股信息
export const topTenShareholder = [
    {
        title: '序号',
        dataIndex: 'index'
    },
    {
        title: '股东名称',
        dataIndex: 'key'
    },
    {
        title: '持股数量',
        dataIndex: 'val'
    },
    {
        title: '持股比例',
        dataIndex: 'valOccur',
        render: val => val + '%'
    }
];

// 实际控制人及变更情况
export const actualController = [
    {
        title: '实际控制人姓名',
        dataIndex: 'actConName'
    },
    {
        title: '实际控制人性质',
        dataIndex: 'actConTyp'
    }
];

// 股东减持情况
export const reduceShareholder = [
    {
        title: '股东名称',
        dataIndex: 'equity_holder'
    },
    {
        title: '减持数量（股）',
        dataIndex: 'shares_change'
    },
    {
        title: '本次减持前股份占总数比例',
        dataIndex: 'original_shareholding_ratio'
    },
    {
        title: '减持后持有数量（股）',
        dataIndex: 'current_shares'
    }
];

// 股东质押情况
export const pledgeShareholder = [
    {
        title: '股东名称',
        dataIndex: 'name'
    },
    {
        title: '持股比例',
        dataIndex: 'name2'
    },
    {
        title: '质押数量',
        dataIndex: 'name3'
    },
    {
        title: '占持股数量',
        dataIndex: 'name4'
    }
];

// 公司近年分红情况
export const companyDividend = [
    {
        title: '年份',
        dataIndex: 'endDate',
        render: val => fieldAnomaly(val)
    },
    {
        title: '股东大会公告日',
        dataIndex: 'SharGenMeetAnnoDate',
        render: val => fieldAnomaly(val)
    },
    {
        title: '股权登记日',
        dataIndex: 'RegiDate',
        render: val => fieldAnomaly(val)
    },
    {
        title: '除权除息日',
        dataIndex: 'ExDiviDate',
        render: val => fieldAnomaly(val)
    },
    {
        title: '派息日',
        dataIndex: 'DeclarationDate',
        render: val => fieldAnomaly(val)
    },
    {
        title: '每股分红送转',
        dataIndex: 'DiviPerShare',
        render: val => fieldAnomaly(val)
    },
    {
        title: '每股税前股利',
        dataIndex: 'DiviPerSharePreTax',
        render: val => fieldAnomaly(val)
    },
    {
        title: '每股转增股本',
        dataIndex: 'CapiPerShare',
        render: val => fieldAnomaly(val)
    },
    {
        title: '年度累计分红金额（万）',
        dataIndex: 'AnnuCumuBonus',
        render: val => fieldAnomaly(val)
    },
    {
        title: '当年实现净利润',
        dataIndex: 'NETPROFIT',
        render: val => fieldAnomaly(val)
    },
    {
        title: '三年累计分红占比',
        dataIndex: 'CumuBonRatio3year',
        render: val => val ? fieldAnomaly(val) + '%' : fieldAnomaly(val)
    }
];

// 重要指标变动说明
export const indexChangeExplain = [
    {
        title: '变动科目',
        dataIndex: 'changesubject'
    },
    {
        title: '本期数值',
        dataIndex: 'newval'
    },
    {
        title: '上期数值',
        dataIndex: 'oldval'
    },
    {
        title: '变动幅度',
        dataIndex: 'changeper'
    },
    {
        title: '变动原因',
        dataIndex: 'changereason'
    }
];

// 同行业公司财务摘要
export const IndustryTableTitle = [
    {
        title: '代码',
        dataIndex: 'symbol',
        width: 80
    },
    {
        title: '证券简称',
        dataIndex: 'sesname',
        width: 115
    },
    {
        title: '营业收入',
        dataIndex: 'bizinco'
    },
    {
        title: '营收增长率',
        dataIndex: 'bizincozzl',
        width: 90,
        render: v => (v * 100).toFixed(2) + '%'
    },
    {
        title: '利润率',
        dataIndex: 'netprofit'
    },
    {
        title: '扣非净利润',
        dataIndex: 'npcut'
    },
    {
        title: '毛利率',
        dataIndex: 'grossrate',
        width: 80,
        render: v => (v * 100).toFixed(2) + '%'
    },
    {
        title: 'ROE(%)',
        dataIndex: 'a20',
        width: 80,
        render: v => (v * 100).toFixed(2) + '%'
    }
];



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/columns.jsx